"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var icons_1 = require("../icons");
var env_1 = require("../Link/env");
function Notification(props) {
    var className = props.className, message = props.message, _a = props.type, type = _a === void 0 ? 'info' : _a, onClose = props.onClose, rootHtmlProps = props.rootHtmlProps, style = props.style;
    var _b = react_1.useState(true), visible = _b[0], setVisible = _b[1];
    var prefix = ConfigProvider_1.usePrefix('notification');
    var typePrefix = utils_1.concat(prefix, type);
    var iconPrefix = utils_1.concat(prefix, 'icon');
    var closePrefix = utils_1.concat(prefix, 'close');
    var innerIcon = getIconByType(type);
    var cls = classnames_1.default(className, prefix, typePrefix, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    function handleClose() {
        setVisible(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }
    if (visible === false) {
        return null;
    }
    return (react_1.default.createElement(env_1.EnvProvider, { isBlue: type === 'info' },
        react_1.default.createElement("div", tslib_1.__assign({}, rootHtmlProps, { className: cls, style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style) }),
            react_1.default.createElement("div", { className: iconPrefix }, innerIcon),
            message,
            react_1.default.createElement("span", { className: closePrefix, onClick: handleClose },
                react_1.default.createElement(icons_1.CloseIcon, null)))));
}
exports.default = Notification;
function getIconByType(type) {
    switch (type) {
        case 'info':
        default:
            return react_1.default.createElement(icons_1.InfoIcon, null);
        case 'success':
            return react_1.default.createElement(icons_1.CheckCircleIcon, null);
        case 'error':
            return react_1.default.createElement(icons_1.CloseCircleIcon, null);
        case 'warning':
            return react_1.default.createElement(icons_1.TipIcon, null);
    }
}
//# sourceMappingURL=index.js.map